module.exports = {
  errors:{
    "INSTRUCTION_TOO_LONG": "您的提示词过长，超过 1000 字符。"
  },
  Questionnaire:{
    title:'文献综述生成系统调查问卷',
    p1:'您好，我们是来自香港理工大学计算机系的研究团队，正在研究自动文献综述生成。',
    p2:'我们邀请您花几分钟时间分享您的反馈和建议，以帮助改进我们的系统。如果您通过继续填写此问卷表示同意，您的匿名回复可能会用于未来的研究。',
    submit:"提交",
    thx:"谢谢您的参与！",
    multiSelectNoResult:"没有找到匹配项，请输入其他内容。"
  },
  FooterView: {
    copyright: "版权所有 2025 - 保留所有权利。",
    icp: "粤ICP备2024229891号-1",
  },
  HeaderView: {
    HeaderHome: {
      backToHome: "回到主页",
    },
    HeaderTutorial: {
      usageInstructions: "使用教程",
      comingSoon: "尚未开放，敬请期待！",
      close: "关闭",
    },
    HeaderFAQ:{
      faq:'常见问题',
      answerText:'回复',
    },
    HeaderTerms: {
      disclaimer: "使用条款",
      p_0:"本工具为学术研究目的开发，仅限用于合法、非商业性研究活动。使用前请仔细阅读以下条款。用户一旦开始使用本工具，即表示已明确知悉并同意以下全部内容：",
      h4_1:"免责声明",
      p_1_a:"本工具生成的内容可能包含基于公开文献的自动化分析结果，不代表开发团队对内容准确性、合法性或道德性的认可。用户应在专业领域咨询合格人士后再做出决策。",
      p_1_b:"开发团队已采取合理的技术措施以确保生成内容质量，但并不对非恶意错误或技术缺陷导致的内容不准确承担责任。用户使用时应谨慎核实生成内容的准确性和适用性，尤其当涉及医疗、金融、法律等高风险领域时。",
      p_1_c:"用户明确理解并接受，由于本工具的技术限制，生成的报告可能存在错误或不准确的信息。开发团队不对因用户未充分核实内容或误用生成内容而造成的任何损失承担责任。",
      h4_2:"禁止行为与责任追究",
      p_2_a:"用户不得将本工具用于任何违反法律法规、公序良俗或侵犯知识产权的用途，包括但不限于非法、有害、暴力、种族歧视、色情、诽谤、侵犯隐私或其他不当用途。",
      p_2_b:"如用户违反上述规定，开发团队保留终止服务并追究相关法律责任的权利。",
      h4_3:"隐私政策",
      p_3_a:"本工具尊重并保护用户隐私，默认情况下不主动收集或共享用户的个人数据。",
      p_3_b:"为优化服务性能，开发团队可能仅收集匿名化的使用数据（如访问时间、操作类型、设备类别或IP地址等技术日志），此类数据无法关联到个人身份。我们将严格遵守相关法律法规（包括但不限于GDPR、CCPA），并采用合理的安全措施对数据进行存储、加密和定期删除。",
      h4_4:"用户权利与服务终止",
      p_4_a:"用户可自主决定是否使用本工具提供的研究预览功能，并有权随时停止使用。",
      p_4_b:"开发团队保留在用户违反使用条款或因技术维护、升级等原因暂停或终止服务的权利，并将在合理情况下提前通知用户。",
      h4_5:"适用法律与争议解决",
      p_5_a:"本使用条款适用中华人民共和国法律。如因本工具使用或条款内容产生任何争议，双方应尽力友好协商解决。协商未果，双方同意将争议提交至开发团队所在地人民法院管辖。",
      h4_6:"条款的有效性与修改",
      p_6_a:"本条款以显著方式展示于用户首次使用或注册页面，用户需明确阅读并同意后方可使用本工具。开发团队保留根据实际需要修改或更新条款内容的权利，条款修改后将及时通知用户。如用户继续使用本工具，视为接受更新后的条款。",
      h4_7:"联系信息",
      p_7_a:"如您对本工具的功能、隐私保护措施、使用条款的内容、潜在风险或收益存在任何疑问、意见或投诉，请通过在线反馈渠道与我们联系，或发送邮件至 service.write4u{'@'}outlook.com。",
      p_7_b:"请不要直接联系文章作者！",
      p_7_c:"本条款的最终解释权归开发团队所有。",
      content: `<p class="my-2 text-base text-slate-800 dark:text-black">
      本工具为学术研究目的开发，仅限用于合法、非商业性研究活动。使用前请仔细阅读以下条款。用户一旦开始使用本工具，即表示已明确知悉并同意以下全部内容：
    </p>
    <h4 class="text-lg font-medium text-slate-800 dark:text-black">免责声明</h4>
    <p class="my-2 text-base text-slate-800 dark:text-black">
      本工具生成的内容可能包含基于公开文献的自动化分析结果，不代表开发团队对内容准确性、合法性或道德性的认可。用户应在专业领域咨询合格人士后再做出决策。
    </p>
    <p class="my-2 text-base text-slate-800 dark:text-black">
      开发团队已采取合理的技术措施以确保生成内容质量，但并不对非恶意错误或技术缺陷导致的内容不准确承担责任。用户使用时应谨慎核实生成内容的准确性和适用性，尤其当涉及医疗、金融、法律等高风险领域时。
    </p>
    <p class="my-2 text-base text-slate-800 dark:text-black">
      用户明确理解并接受，由于本工具的技术限制，生成的报告可能存在错误或不准确的信息。开发团队不对因用户未充分核实内容或误用生成内容而造成的任何损失承担责任。
    </p>
    <h4 class="text-lg font-medium text-slate-800 dark:text-black">禁止行为与责任追究</h4>
    <p class="my-2 text-base text-slate-800 dark:text-black">
      用户不得将本工具用于任何违反法律法规、公序良俗或侵犯知识产权的用途，包括但不限于非法、有害、暴力、种族歧视、色情、诽谤、侵犯隐私或其他不当用途。
    </p>
    <p class="my-2 text-base text-slate-800 dark:text-black">
      如用户违反上述规定，开发团队保留终止服务并追究相关法律责任的权利。
    </p>
    <h4 class="text-lg font-medium text-slate-800 dark:text-black">隐私政策</h4>
    <p class="my-2 text-base text-slate-800 dark:text-black">
      本工具尊重并保护用户隐私，默认情况下不主动收集或共享用户的个人数据。
    </p>
    <p class="my-2 text-base text-slate-800 dark:text-black">
      为优化服务性能，开发团队可能仅收集匿名化的使用数据（如访问时间、操作类型、设备类别或IP地址等技术日志），此类数据无法关联到个人身份。我们将严格遵守相关法律法规（包括但不限于GDPR、CCPA），并采用合理的安全措施对数据进行存储、加密和定期删除。
    </p>
    <h4 class="text-lg font-medium text-slate-800 dark:text-black">用户权利与服务终止</h4>
    <p class="my-2 text-base text-slate-800 dark:text-black">
      用户可自主决定是否使用本工具提供的研究预览功能，并有权随时停止使用。
    </p>
    <p class="my-2 text-base text-slate-800 dark:text-black">
      开发团队保留在用户违反使用条款或因技术维护、升级等原因暂停或终止服务的权利，并将在合理情况下提前通知用户。
    </p>
    <h4 class="text-lg font-medium text-slate-800 dark:text-black">适用法律与争议解决</h4>
    <p class="my-2 text-base text-slate-800 dark:text-black">
      本使用条款适用中华人民共和国法律。如因本工具使用或条款内容产生任何争议，双方应尽力友好协商解决。协商未果，双方同意将争议提交至开发团队所在地人民法院管辖。
    </p>
    <h4 class="text-lg font-medium text-slate-800 dark:text-black">条款的有效性与修改</h4>
    <p class="my-2 text-base text-slate-800 dark:text-black">
      本条款以显著方式展示于用户首次使用或注册页面，用户需明确阅读并同意后方可使用本工具。开发团队保留根据实际需要修改或更新条款内容的权利，条款修改后将及时通知用户。如用户继续使用本工具，视为接受更新后的条款。
    </p>
    <h4 class="text-lg font-medium text-slate-800 dark:text-black">联系信息</h4>
    <p class="my-2 text-base text-slate-800 dark:text-black">
      如您对本工具的功能、隐私保护措施、使用条款的内容、潜在风险或收益存在任何疑问、意见或投诉，请通过在线反馈渠道与我们联系，或发送邮件至 <a class='underline' href='mailto:service.write4u{'@'}outlook.com'>service.write4u{'@'}outlook.com</a>。<strong>请不要直接联系文章作者！</strong>
    </p>
    <p class="my-2 text-base text-slate-800 dark:text-black">
      本条款的最终解释权归开发团队所有。
    </p>`,
      disagree: "不同意",
      agree: "我已阅读并同意",
    },
    HeaderAbout: {
      aboutUs: "关于我们",
      researchTeam: "关于我们",
      research:"研究团队",
      develop:"开发团队",
      close: "关闭",
      note1: "如有任何查询和意见，您可以联系 service.write4u{'@'}outlook.com， 我们将尽快跟进。", // eslint-disable-line
      note2: "请不要直接联系文章作者！", // eslint-disable-line
      note3: "", // eslint-disable-line
      first_p1:"帮你写这个软件是我们在 AAAI 2025 上发表的论文 ",
      first_p2:" 的 demo。基于此，我们正在扩展一篇期刊文章，AAAI 的审阅者建议我们收集更多实际用户的反馈意见。如果您在使用这个软件之余，可以帮我们填写一份",
      first_p3:"，我们将不胜感谢！ ",
      user_feedback:"用户反馈表"
    },
    HeaderFeedback: {
      feedback: "意见反馈",
      subject: "邮件主题",
      subjectPlaceholder: "请输入邮件主题...",
      email: "邮箱",
      emailPlaceholder: "请输入邮箱...",
      anonymous: "匿名",
      contactMe: "请联系我",
      content: "反馈内容",
      feedbackSuccess: "反馈成功",
      feedbackFailed: "反馈失败，请稍后再试",
      contentPlaceholder: "例如，请添加某会议的风格模板...",
      note1: "如有任何查询和意见，您可以在上面的文本框中直接输入，也可以填写下 ",
      questionnaireBtn:"意见反馈表",
      note11:"，也可以联系 service.write4u{'@'}outlook.com， 我们将尽快跟进。", // eslint-disable-line
      note2: "请不要直接联系文章作者！", // eslint-disable-line
      note3: "", // eslint-disable-line
      cancel: "取消",
      submit: "提交",
      attachInfomation: "如果您不介意，请提供以下信息",
      attachSettings: "你的设置",
      attachScreenshot: "你的生成结果",
    },
    HeaderNews: {
      latestAnnouncement: "最新公告",
      comingSoon: "尚未开放，敬请期待！",
      close: "关闭",
    },
  },
  ShowMoreDown: {
    showMore: "显示更多",
    hideMore: "收起选项",
  },
  RadioGroupMore: {
    showMore: "显示更多",
  },
  FileUpload: {
    dragAndDrop: "将文件拖放到此处，或",
    clickToUpload: "点击上传",
    supportedFormats: "支持",
    currentFile: "当前文件：",
    wrongFormat:"请上传.docx、.png、.pdf 格式的文件",
    wrongFileSize:"请上传小于10MB的文件"
  },
  ProgressAPI: {
    titleText: "任务进度",
    completedTasksText: "任务已完成。",
    retryText: "重试",
    remainingTimeText: "预计剩余",
    estimateRemainingTimeText: "正在估计剩余时间。",
    completedText: "完成",
    secondsText: "秒",
  },
  HomeView: {
    HomeWelcome: {
      writeForYou: "帮你写",
      writeForYouSubtitle: "WRITE FOR YOU",
      writeForYouDescription: `一键生成专业综述    
      全面精准安全可靠`,
      lightMode: "白天模式",
      darkMode: "黑夜模式",
    },
    HomeInput: {
      uploadFile: "上传文件",
      cancel: "取消",
      submit: "确认",
      textInstruction: "文本描述",
      textInstructionTitle: "生成要求",
      textInstructionPlaceholder: "例如，请生成一个关于人工智能的综述报告。",
      instructionPlaceholder: "您可以在对话框中输入生成要求，或按右侧按钮上传描述文件(.pdf, .docx, .jpg, .jpeg, .png)",
    },
    HomeWords: {
      words: "字数设置",
      wordsUnit: "字",
      wordsPlaceholder: "请输入字数...",
      confirm: "确定",
    },
    HomeGenerate: {
      generate: "开始生成",
      waitTime: "预计：",
      minutes: "分钟",
      instruction: "请输入或上传指令",
      noSources: "请从中英文数据库中至少选择一个作为文献来源。",
      vipTitle: "您的生成时间较长",
      inviteCodeLabel: "邀请码",
      inviteCodePlaceholder: "请输入邀请码",
      vipNote: "由于当前用户需求量较大，服务器资源紧张，请您将生成时间限制在 1 小时之内。",
      currentTime: "当前耗时为",
      vipNote2: "您可以调整您的设置，也可以使用邀请码进行耗时 1 小时以上的生成。感谢您的支持！",
      confirm: "确认",
      cancel: "取消",
      inviteCodeError: "邀请码错误",
    },
    HomeForm: {
      advancedSettings: "高级设置",
      numCitations: "参考文献数",
      numCitationsPlaceholder: "请输入参考文献数...",
      template: "报告的排版风格",
      abstract: "摘要设置",
      otherAttachments: "同时生成",
      appendix: "报告附录",
      diagram: "报告的图表",
      sources: "报告的文献来源",
      plugins: "报告的强化工具"
    },
    HomeProgress: {
      createSectionPlans: "创建章节计划中。",
      createSectionContents: "创建章节内容中。",
      searchRelatedPapers: "搜索相关论文中。",
      createSectionDiagrams: "创建章节图表中。",
      createPaperInfo: "创建论文信息中。",
      createPaperElements: "渲染论文模板中。",
      downloadPaper: "下载论文文件中。",
      sendPaperEmail: "完成后发送邮件中。",
      downloadPDF: "下载PDF中。",
      emailHint:
        "如果您觉得等待时间过长，也可输入您的邮箱，我们将发送生成文件至您的邮箱。发送完成后我们将不会保留您的邮箱及个人信息。",
      emailPlaceholder: "可以输入您的邮箱...",
      subscribe: "完成后发送",
      message: "设置成功，请稍后查看邮箱。",
      startNext: "回到主页",
      questionnaireDesc:"您在等待的时候，如果您曾查看过我们生成的内容，且您不介意，麻烦您抬抬发财的小手，帮我们问做个",
      questionnaireBtn:"问卷（耗时约1分钟）",
      questionnaireDesc2:"。 ：)",
      noAllowed:"请先回到主页输入或上传生成要求。"
    },
    DownloadPaper: {
      download: "下载报告",
    },
  },
};
